import { toggle } from "@otto-ec/global-resources/toggle";
import { assignments, isOnexGroup } from "@otto-ec/global-resources/onex";

const DEFAULT_PAGE_CLUSTER_WHITELIST = ["Storefront", "Einstiegsseite", "Produktliste", "Suchergebnisseite", "Artikeldetailseite", "Artikelkombiseite"];

interface ShopIntegrationConfig {
    whitelist?: string[];
}

export class ShopIntegrationService {
    private config: ShopIntegrationConfig;

    constructor(config: ShopIntegrationConfig = {}) {
        this.config = {
            whitelist: config.whitelist || DEFAULT_PAGE_CLUSTER_WHITELIST,
        };
    }

    /**
 *
 */
    async canShowChatbotEntrypoint(): Promise<boolean> {
        const emergencyToggle = toggle.get("nucleus_chatbot_emergency_disable_entrypoint", false);

        /*                                                                                                               */
        return !emergencyToggle && this.isInWhitelistedPageCluster();
    }

    /**
 *
 */
    async isLoggedInUserInApp(): Promise<boolean> {
        const [isInApp, userIsLoggedIn] = await Promise.all([this.isInApp(), this.userIsLoggedIn()]);

        /*                                                */
        if (!isInApp) {
            return false;
        }

        /*                                    */
        return userIsLoggedIn;
    }

    /**
 *
 */
    getPageCluster(): string | null {
        return window.o_util.misc.getPagecluster();
    }

    isInWhitelistedPageCluster(): boolean {
        const pageCluster = this.getPageCluster();
        return !!pageCluster && this.config.whitelist!.includes(pageCluster);
    }

    /**
 *
 */
    userIsLoggedIn(): Promise<boolean> {
        return this.retryUntilResolved(() => window.o_user?.loginState?.presenter?.isLoggedIn(), false);
    }

    /**
 *
 */
    isInApp(): Promise<boolean> {
        return this.retryUntilResolved(() => window.o_apps?.runningInApp(), false);
    }

    /**
 *
 *
 *
 *
 *
 *
 */
    private retryUntilResolved<T, D>(condition: () => T | undefined, defaultValue: D, retries: number = 20, delay: number = 100): Promise<T | D> {
        return new Promise((resolve) => {
            const attempt = () => {
                const result = condition();
                if (result !== undefined) {
                    resolve(result);
                } else if (retries > 0) {
                    retries--;
                    setTimeout(attempt, delay);
                } else {
                    resolve(defaultValue); /*      */
                }
            };
            attempt();
        });
    }

    /**
 *
 *
 *
 */
    async waitForAssignments(timeout = 500): Promise<boolean> {
        return new Promise((resolve) => {
            let settled = false;
            const unsubscribe = assignments.subscribe((value: any) => {
                if (value && !settled) {
                    settled = true;
                    resolve(true);
                }
            });
            if (settled) unsubscribe();
            setTimeout(() => {
                if (!settled) {
                    settled = true;
                    unsubscribe();
                    resolve(false);
                }
            }, timeout);
        });
    }

    /**
 *
 */
    async isInOnexTestGroup(timeout = 500) {
        const assignmentsReady = await this.waitForAssignments(timeout);
        if (assignmentsReady) {
            return isOnexGroup("E3510", "TestGroup");
        }
    }
}

export default new ShopIntegrationService();
